import React from "react";

type CircularLoaderProps = {
  size?: number; // px
  message?: string;
  center?: boolean;
  minHeight?: string;
};

export function CircularLoader({
  size = 40,
  message = "Loading...",
  center = true,
  minHeight = "200px",
}: CircularLoaderProps) {
  const Loader = (
    <div
      className="rounded-full border-4 border-t-transparent animate-spin border-gray-400"
      style={{ width: size, height: size }}
    />
  );

  if (!center) {
    return (
      <div className="flex flex-col items-center space-y-3">
        <p className="text-gray-600 text-sm">{message}</p>
        {Loader}
      </div>
    );
  }

  return (
    <div
      className="flex flex-col justify-center items-center w-full h-full space-y-3"
      style={{ minHeight }}
    >
      <p className="text-gray-600 text-sm">{message}</p>
      {Loader}
    </div>
  );
}
